import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../../components/button/Button.tsx";
import Modal from "../../components/modal/Modal";

const IconWrapper = styled.div`
  color: var(--soremo-light-gray);
  font-size: 96px;
`;

const Message = styled.p.attrs({
  className: "bodytext-13",
})`
  color: var(--soremo-text);
  line-height: 1.6;
  text-align: center;
  padding: 0 4px;
`;

const PasswordResetSent: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Modal variant="auth">
      <div className="u-col-center u-gap32">
        <IconWrapper className="material-symbols-rounded">
          mark_email_read
        </IconWrapper>
        <Message>パスワード再設定のメールを送信しました。</Message>
        <Button
          theme="primary"
          variant="filled"
          size="medium"
          onClick={() => navigate("/signin")}
        >
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default PasswordResetSent;
